import { configure, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules';

Object.keys(rules).forEach(rule => extend(rule, rules[rule]));

configure({
    classes: {
        invalid: 'is-invalid',
    },
});
